import can from 'can';
import {BaseMap} from '../../js/usga.base-map';

export const LeaderBoardBaseMap = BaseMap.extend({
    define: {
        lbType: {
            type: 'string',
            value: ''
        },
		championshipType: {
			type: 'string',
			value: ''
		},
        screenSize: {
            type: 'string',
            value: 'infinity'
        }
    },
    isTeamStrokeLb: can.compute(function() {
        return this.attr('lbType') == 'teamStroke';
    }),
    isIndStateStrokeLb: can.compute(function() {
        return this.attr('lbType') == 'individualStateStroke';
    }),
    isIndIntlStrokeLb: can.compute(function() {
        return this.attr('lbType') == 'individualIntlStroke';
    }),
    isIndMatchPlayLb: can.compute(function() {
        return this.attr('lbType') == 'individualMatchPlay';
    }),
    isFourBallMatchPlayLb: can.compute(function() {
        return this.attr('lbType') == 'fourballMatchPlay';
    }),
    isFourBallIntlStrokeLb: can.compute(function() {
        return this.attr('lbType') == 'fourballIntlStroke';
    }),
	isAmateurChampionship: can.compute(function() {
		return this.attr('championshipType') == 'amateur';
	}),
	isAmateurMatchPlayLb: can.compute(function() {
		return this.attr('lbType') == 'individualMatchPlay'  && this.attr('championshipType') == 'amateur';
	}),
	isAmateurIntlStrokeLb: can.compute(function() {
		return this.attr('lbType') == 'individualIntlStroke' && this.attr('championshipType') == 'amateur';
	}),
    isTeamMatchPlayLb: can.compute(function() {
        return this.attr('lbType') == 'teamMatchPlay';
    }),
    isFourballChampionship: can.compute(function() {
        return this.attr('lbType') == 'fourballMatchPlay' || this.attr('lbType') == 'fourballIntlStroke' || this.attr('lbType') == 'fourball';
    }),
	isCupChampionship: can.compute(function() {
		return this.attr('championshipType') == 'cup';
	}),
	isStateChampionship: can.compute(function() {
		return this.attr('championshipType') == 'state';
	}),
	isOpenChampionship: can.compute(function() {
		return this.attr('championshipType') == 'open';
	}),
    hasMatchStatusBar: can.compute(function() {
        //TODO figure out requirements for status bar
        return false /*this.attr('lbType') == 'individualMatchPlay' || this.attr('lbType') == 'fourballMatchPlay'*/;
    }),
    isMobileScreen: can.compute(function() {
        return this.attr('screenSize') == 'small';
    }),
	isTabletDownScreen: can.compute(function() {
		return this.attr('screenSize') == 'big' || this.attr('screenSize') == 'medium' || this.attr('screenSize') == 'small';
	}),
	isTabletLandscapeDownScreen: can.compute(function() {
		return this.attr('screenSize') == 'bigger' || this.attr('screenSize') == 'big' || this.attr('screenSize') == 'medium' || this.attr('screenSize') == 'small';
	})
});